var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"shrink"},[_c('BackBtn')],1),_c('v-spacer'),_c('v-col',{staticClass:"text-right"},[_c('h1',{staticClass:"display-1 font-weight-light"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('small',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }